import { css } from '@emotion/react'
import { Tag, Theme, Tooltip, useTheme } from 'bold-ui'
import { green, orange } from 'bold-ui/lib/styles/colors'

interface StatusCadastroImovelTagProps {
  isCadastroCompleto: boolean
  isStatusRecusaCadastro: boolean
  stAtivo?: boolean
}

export function StatusCadastroImovelTag({
  isCadastroCompleto,
  isStatusRecusaCadastro,
  stAtivo,
}: Readonly<StatusCadastroImovelTagProps>) {
  const theme = useTheme()
  const classes = createStyles(theme)

  if (stAtivo === false) {
    return <Tag style={classes.tagInativo}>Inativo</Tag>
  }

  if (isStatusRecusaCadastro) {
    return <Tag style={classes.tagIncompletoOuRecusado}> Recusa de cadastro </Tag>
  }

  const isCompletoText = isCadastroCompleto
    ? 'Todos os campos do cadastro do imóvel estão preenchidos.'
    : 'Alguns campos do cadastro do imóvel ainda não foram preenchidos.'

  return (
    <Tooltip text={isCompletoText}>
      {isCadastroCompleto ? (
        <Tag style={classes.tagCompleto}>Completo</Tag>
      ) : (
        <Tag style={classes.tagIncompletoOuRecusado}>Incompleto</Tag>
      )}
    </Tooltip>
  )
}

const createStyles = (theme: Theme) => ({
  tagCompleto: css`
    background-color: transparent;
    border: 1px solid;
    color: ${green.c40};
  `,
  tagIncompletoOuRecusado: css`
    background-color: transparent;
    border: 1px solid;
    color: ${theme.pallete.gray.c40};
  `,
  tagInativo: css`
    background-color: transparent;
    border: 1px solid;
    color: ${orange.c40};
  `,
})
